import { AgentsActionTypes } from './constants';

export const agentsApiResponseSuccess = (actionType: string, data: any) => ({
    type: AgentsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const agentsApiResponseError = (actionType: string, error: any) => ({
    type: AgentsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const agentsGetAllAgents = (userId: string, query?: string) => ({
    type: AgentsActionTypes.READ_AGENTS_REQUEST,
    payload: { userId, query },
});

export const agentsCreateAgent = (userId: string, agent: any, query?: string, callback?: () => void) => ({
    type: AgentsActionTypes.CREATE_AGENT_REQUEST,
    payload: { userId, agent, query, callback },
});

export const agentsUpdateAgent = (userId: string, agentId: string, agent: any, query?: string) => ({
    type: AgentsActionTypes.UPDATE_AGENT_REQUEST,
    payload: { userId, agentId, agent, query },
});

export const agentsDeleteAgent = (userId: string, agentId: string, query?: string) => ({
    type: AgentsActionTypes.DELETE_AGENT_REQUEST,
    payload: { userId, agentId, query },
});

export const agentsResetState = () => ({
    type: AgentsActionTypes.RESET_AGENT_STATE,
});
